import { cloneDeep } from 'lodash';

const d = new Date();
const year = d.getFullYear();

export const filteredStudyRequest = studyData => {
  const copyStudyData = cloneDeep(studyData);
  const filteredStudy = copyStudyData.filter(
    element => element.isAnyChildSelected === true || element.selected === true
  );
  filteredStudy.forEach(data => {
    if (data.nodes) {
      data.nodes = data.nodes.filter(
        element => element.isAnyChildSelected || element.selected
      );
      data.nodes.forEach(e => {
        if (e.nodes) {
          e.nodes = e.nodes.filter(
            element => element.isAnyChildSelected || element.selected
          );
          e.nodes.forEach(e1 => {
            if (e1.nodes) {
              e1.nodes = e1.nodes.filter(
                element => element.isAnyChildSelected || element.selected
              );
            }
          });
        }
      });
    }
  });
  return filteredStudy;
};
export const filteredProdData = prodData => {
  const selectedProdData = [];
  const copyProdData = cloneDeep(
    prodData.filter(data => data.selected || data.isAnyChildSelected)
  );

  copyProdData.map(e => {
    const isChildSel = false;
    let isAnyChild = [];

    if (e.modules) {
      e.modules.map(child => {
        if (child.modules) {
          child.modules = child.modules.filter(e2 => e2.selected === true);
          isAnyChild.push(child);
        } else {
          isAnyChild = e.modules.filter(e1 => e1.selected === true);
        }

        return child;
      });
    }
    if (e.selected || isAnyChild.length || isChildSel) {
      e.modules = isAnyChild;
      selectedProdData.push(e);
    }
    return e;
  });
  return selectedProdData;
};
export const setSelected = (data, twoYrBackData) => {
  if (!data.selected) {
    data.autoAdd = false;
    data.autoRemove = false;
    data.historicalData = '';
  }
  if (data.nodes) {
    data.isAnyChildSelected = false;
    if (data.selected === true && !twoYrBackData) {
      data.historicalData = '5';
    } else {
      data.historicalData = '';
      data.autoAdd = false;
      data.autoRemove = false;
    }
    data.nodes.map(e => {
      if (e.nodes) {
        e.selected = data.selected;
        if (e.selected === true && !twoYrBackData) {
          e.historicalData = '5';
        } else {
          e.historicalData = '';
        }
        e.isAnyChildSelected = false;
        setSelected(e,twoYrBackData);
      } else if (e.autoAdd) {
        e.selected = data.selected;
        if (e.selected === true && !twoYrBackData) {
          e.historicalData = '5';
        } else {
          e.historicalData = '';
        }
        e.isAnyChildSelected = false;
      } else if (e.optionName <= year) {
        if(twoYrBackData && e.optionName == year-2){
          e.selected = data.selected;
        }else if(!twoYrBackData){
        e.selected = data.selected;
        }
        if (e.selected === true && !twoYrBackData) {
          e.historicalData = '5';
        } else {
          e.historicalData = '';
        }
        e.isAnyChildSelected = false;
      } else if (!data.selected) {
        e.selected = data.selected;
      }

      return e;
    });
  }
  // setStudyData([...studyData]);
};
export const setIsAnychildSelected = e => {
  e.isAnyChildSelected = false;
  const isAnyChildSel = e.nodes.some(e => e.selected === true);
  const isChildDataSelected = e.nodes.some(e => e.isAnyChildSelected === true);
  const isAllChecked = e.nodes.every(e => e.selected === true);
  e.selected = isAllChecked;

  e.isAnyChildSelected =
    isChildDataSelected || (isAnyChildSel && !isAllChecked);
  e.autoRemove = e.selected || e.isAnyChildSelected ? e.autoRemove : false;
  e.autoAdd = e.selected || e.isAnyChildSelected ? e.autoAdd : false;
  e.historicalData = e.selected || e.isAnyChildSelected ? e.historicalData : '';
  return e;
};
export const updateAnychildSelectedValue = (data, child) => {
  data.map(e => {
    if (e.nodes) {
      const selectedDataChild = e.nodes.find(
        element => element.optionId === child.optionId
      );
      const isAnyChildSelected = e.nodes.some(
        element => element.isAnyChildSelected === true
      );
      const isAnyChildSel = e.nodes.some(e => e.selected === true);
      if (selectedDataChild) {
        const isAllChecked = e.nodes.every(e => e.selected === true);
        e.selected = isAllChecked;
        e.isAnyChildSelected =
          isAnyChildSelected || (isAnyChildSel && !isAllChecked);
        e.autoRemove =
          e.selected || e.isAnyChildSelected ? e.autoRemove : false;
        e.autoAdd = e.selected || e.isAnyChildSelected ? e.autoAdd : false;
        e.historicalData =
          e.selected || e.isAnyChildSelected ? e.historicalData : '';
        updateAnychildSelectedValue(data, e);
      } else {
        updateAnychildSelectedValue(e.nodes, child);
      }
    }
    return e;
  });

  // setStudyData([...studyData]);
};

export const setAutoAdd = (data, is2YrBackData, endDate) => {
  if (data.nodes) {
    data.nodes.map(e => {
      if (e.nodes) {
        e.autoAdd =
          e.selected || e.isAnyChildSelected ? data.autoAdd : e.autoAdd;
        setAutoAdd(e, is2YrBackData, endDate);
      } else if (e.optionName > year && !is2YrBackData ) {
          e.selected = data.autoAdd;
        } else if(is2YrBackData && e.optionName > year-2){
          if(e.optionName == endDate || e.optionName == endDate -1){
            e.selected = false;
          }else{
            e.selected = data.autoAdd;
          }
    }
    return e;
  })
  // setStudyData([...studyData]);
}
}
export const setAutoRemove = data => {
  if (data.nodes) {
    data.nodes.map(e => {
      if (e.nodes) {
        e.autoRemove =
          e.selected || e.isAnyChildSelected ? data.autoRemove : e.autoRemove;
        setAutoRemove(e);
      }
      return e;
    });
  }
  //setStudyData([...studyData]);
};
